import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiClient } from '@app/core/services/base-api-client.service';
import { LoadingIndicatorService } from '@app/core/services/loading-indicator.service';
import { LogService } from '@app/core/services/log.service';
import { Environment } from '@env/environment';
import { KpaReturnResult } from '@app/core/models/kpa-return-result';
import { Observable, catchError, tap } from 'rxjs';
import { UpcomingTask } from '../models/upcoming-tasks';
import { AssignedDocument } from '../models/assigned-document';
import { OfflineAttachment } from '../models/offline-attachments';

const httpOptions = {
	headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};
export interface IAttachmentService {
	url: string;
	getOfflineAttachment(scheduledId: number): Observable<OfflineAttachment[]>;
	getCompletedOfflineAttachment(trainingId: number): Observable<OfflineAttachment[]>;
	postOfflineAttachments(attachments: OfflineAttachment[]): Observable<boolean>;
}
@Injectable({
	providedIn: 'root',
})
export class AttachmentService extends BaseApiClient implements IAttachmentService {
	/**
	 * The base URL for the API domain.
	 */
	public baseUrl: string;

	/**
	 * The URL to the API endpoint.
	 */
	public url: string;

	constructor(
		private readonly http: HttpClient,
		private readonly log: LogService,
		private readonly loadingIndicatorService: LoadingIndicatorService,
		environment: Environment
	) {
		super();
		this.baseUrl = environment.services['employee'];
		this.url = this.baseUrl + 'attachments';
	}
	/**
	 * Get Offline Attachment
	 * @param scheduledId
	 */
	getOfflineAttachment(scheduledId: number): Observable<OfflineAttachment[]> {
		const url = `${this.url}/Offline?scheduledId=${scheduledId}`;
		const errorHandler = this.createErrorResponseHandler(this.log, undefined, (_) => this.loadingIndicatorService.stopLoading());

		this.loadingIndicatorService.startLoading();
		return this.http.get<OfflineAttachment[]>(url, httpOptions).pipe(
			tap((result) => {
				this.loadingIndicatorService.stopLoading();
			}),
			catchError(errorHandler)
		);
	}
	/**
	 * Get Completed Offline Attachment
	 * @param trainingId
	 */
	getCompletedOfflineAttachment(trainingId: number): Observable<OfflineAttachment[]> {
		const url = `${this.url}/CompletedOffline?trainingId=${trainingId}`;
		const errorHandler = this.createErrorResponseHandler(this.log, undefined, (_) => this.loadingIndicatorService.stopLoading());

		this.loadingIndicatorService.startLoading();
		return this.http.get<OfflineAttachment[]>(url, httpOptions).pipe(
			tap((result) => {
				this.loadingIndicatorService.stopLoading();
			}),
			catchError(errorHandler)
		);
	}
	/**
	 * Insert Offline Attachments
	 * @param attachments
	 */
	postOfflineAttachments(attachments: OfflineAttachment[]): Observable<boolean> {
		const url = `${this.url}/InsertOffline`;
		const errorHandler = this.createErrorResponseHandler(this.log, undefined, (_) => this.loadingIndicatorService.stopLoading());

		this.loadingIndicatorService.startLoading();
		return this.http.post<boolean>(url, attachments, httpOptions).pipe(
			tap((result) => {
				this.loadingIndicatorService.stopLoading();
			}),
			catchError(errorHandler)
		);
	}
}
